import { render } from "./EditListWidget.vue?vue&type=template&id=a2c72160"
import script from "./EditListWidget.vue?vue&type=script&lang=js"
export * from "./EditListWidget.vue?vue&type=script&lang=js"

import "./EditListWidget.vue?vue&type=style&index=0&id=a2c72160&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__